var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconFont = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4717 13.2373C11.0166 13.2373 11.2979 13 11.5 12.4023L12.4932 9.61621H17.5293L18.5312 12.4023C18.7246 13 19.0146 13.2373 19.5596 13.2373C20.166 13.2373 20.5615 12.877 20.5615 12.3145C20.5615 12.1211 20.5264 11.9453 20.4473 11.708L16.5273 1.14355C16.2637 0.431641 15.7891 0.0888672 15.0244 0.0888672C14.2861 0.0888672 13.8115 0.431641 13.5566 1.13477L9.61035 11.752C9.52246 11.9717 9.49609 12.1562 9.49609 12.3408C9.49609 12.8945 9.86523 13.2373 10.4717 13.2373ZM12.9766 8.00781L14.9805 2.27734H15.042L17.0371 8.00781H12.9766ZM1.16406 13.2373C1.6123 13.2373 1.90234 13 2.08691 12.4199L2.68457 10.6709H5.90137L6.49902 12.4287C6.68359 13.0176 6.97363 13.2373 7.43945 13.2373C7.97559 13.2373 8.35352 12.8857 8.35352 12.376C8.35352 12.1826 8.31836 11.9893 8.22168 11.7432L5.67285 4.90527C5.42676 4.2373 4.9873 3.86816 4.27539 3.86816C3.59863 3.86816 3.16797 4.24609 2.92188 4.90527L0.373047 11.7432C0.276367 11.9893 0.241211 12.2002 0.241211 12.376C0.241211 12.8945 0.601562 13.2373 1.16406 13.2373ZM3.11523 9.25586L4.23145 5.80176H4.32812L5.46191 9.25586H3.11523Z",
    fill: "#B2B2BF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconFont);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-font.557995a0915e80d7642a6c0a0b70c254.svg";